module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/invitation-39970abb424caddd438b835c6e810cd9.jpeg";